import { useEffect, useState } from "react";
import { ApiClient } from "@/services/api";
import { Card, LoadingSpinner } from "@/components/shared";

interface ConsentEntry {
  id: string;
  selection_id: string;
  request_id: string;
  agent_id: string;
  method: string;
  consent_granted_at: string;
  revoked_at: string | null;
  request?: { suburb: string; province: string };
  agent?: { display_name: string; agency_name: string };
}

export function ConsentHistory() {
  const [history, setHistory] = useState<ConsentEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const api = new ApiClient();
        const data = await api.get<{ data: ConsentEntry[] }>("/consent-history");
        setHistory(data.data);
      } catch {
        // silent
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  if (loading) return <LoadingSpinner />;

  if (history.length === 0) {
    return (
      <Card>
        <p className="text-white/50 text-center py-4">No consent history yet</p>
      </Card>
    );
  }

  return (
    <div className="space-y-3">
      <h3 className="font-semibold text-white">Consent & Access History</h3>
      {history.map((entry) => (
        <Card key={entry.id} className="text-sm">
          <div className="flex justify-between items-start">
            <div>
              {entry.request && (
                <p className="font-medium text-white">
                  {entry.request.suburb}, {entry.request.province.replace("_", " ")}
                </p>
              )}
              {entry.agent && (
                <p className="text-white/60">
                  Agent: {entry.agent.display_name} ({entry.agent.agency_name})
                </p>
              )}
              <p className="text-xs text-white/50 mt-1">
                Granted: {new Date(entry.consent_granted_at).toLocaleString("en-ZA")}
              </p>
            </div>
            <span
              className={`px-2 py-1 rounded text-xs font-medium ${
                entry.revoked_at
                  ? "bg-red-100 text-red-800"
                  : "bg-green-100 text-green-800"
              }`}
            >
              {entry.revoked_at ? "Revoked" : "Active"}
            </span>
          </div>
          {entry.revoked_at && (
            <p className="text-xs text-red-600 mt-1">
              Revoked: {new Date(entry.revoked_at).toLocaleString("en-ZA")}
            </p>
          )}
        </Card>
      ))}
    </div>
  );
}
